import React from "react";
import { Button, Form, Tab, Nav } from "react-bootstrap";
import './budgetconnectionstab.css'
import { TrashIcon } from "../../../utility/icons/Icons";

const Budgetconnectionstab: React.FC = () => {
    return (
        <>
            <div className="common_card mby_20">
                <div className="top top_bar_flx border_tittle">
                    <div className="top_bar_tittle">
                        <h2 className="mb-2">Medicaid Connections</h2>
                        <p>Connect systems so Waivera can validate eligibility monthly, confirm  minimal tasking via LaSRS, release PAs, auto‑send 837P, and auto‑pull  835.</p>
                    </div>
                    <div className="top_right_flx flex-wrap">
                        <Button variant="primary" className="btn_sm">Add Connection</Button>
                    </div>
                </div>
                <div className="medicaid_card_grid">
                    <div className="common_card common_card_grey medicaid_card">
                        <div className="top top_bar_flx border_tittle mby_16">
                            <div className="top_bar_tittle sm_tittle">
                                <h2 className="mb-1">Gainwell / LMMIS (Medicaid)</h2>
                                <p>837P submission, 835 retrieval via SFTP/API</p>
                            </div>
                            <div className="top_right_flx flex-wrap">
                                <Button variant="light" className="btn_sm"><TrashIcon /> Delete</Button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 col-lg-12 col-xl-6">
                                <Form.Group className="custom_input_flled" controlId="">
                                    <Form.Control type="text" placeholder="SFTP Host" className="filled_white " />
                                </Form.Group>
                            </div>
                            <div className="col-md-6 col-lg-12 col-xl-6">
                                <Form.Group className="custom_input_flled" controlId="">
                                    <Form.Control type="text" placeholder="SFTP Username" className="filled_white " />
                                </Form.Group>
                            </div>
                            <div className="col-md-6 col-lg-12 col-xl-6">
                                <Form.Group className="custom_input_flled" controlId="">
                                    <Form.Control type="text" placeholder="SFTP Path (in/out)" className="filled_white " />
                                </Form.Group>
                            </div>
                            <div className="col-md-6 col-lg-12 col-xl-6">
                                <Form.Group className="custom_input_flled" controlId="">
                                    <Form.Control type="text" placeholder="API Key (if applicable)" className="filled_white " />
                                </Form.Group>
                            </div>
                        </div>
                        <div className="form_btn_flx justify-content-start">
                            <Button variant="primary" className="btn_sm">Test</Button>
                            <Button variant="light" className="btn_sm">Save</Button>
                        </div>
                    </div>
                    <div className="common_card common_card_grey medicaid_card">
                        <div className="top top_bar_flx border_tittle mby_16">
                            <div className="top_bar_tittle sm_tittle">
                                <h2 className="mb-1">LaMEDS Eligibility (270/271)</h2>
                                <p>Monthly batch 270; store 271 for audit</p>
                            </div>
                            <div className="top_right_flx flex-wrap">
                                <Button variant="light" className="btn_sm"><TrashIcon /> Delete</Button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 col-lg-12 col-xl-6">
                                <Form.Group className="custom_input_flled" controlId="">
                                    <Form.Control type="text" placeholder="API Endpoint / SFTP Host" className="filled_white " />
                                </Form.Group>
                            </div>
                            <div className="col-md-6 col-lg-12 col-xl-6">
                                <Form.Group className="custom_input_flled" controlId="">
                                    <Form.Control type="text" placeholder="Credentials / Token" className="filled_white " />
                                </Form.Group>
                            </div>
                        </div>
                        <div className="form_btn_flx justify-content-start">
                            <Button variant="primary" className="btn_sm">Test</Button>
                            <Button variant="light" className="btn_sm">Save</Button>
                        </div>
                    </div>
                    <div className="common_card common_card_grey medicaid_card">
                        <div className="top top_bar_flx border_tittle mby_16">
                            <div className="top_bar_tittle sm_tittle">
                                <h2 className="mb-1">LaSRS (PA / minimal tasking)</h2>
                                <p>Ingest PA/visit EDI; Waivera determines billable, then reconcile vs LaSRS release</p>
                            </div>
                            <div className="top_right_flx flex-wrap">
                                <Button variant="light" className="btn_sm"><TrashIcon /> Delete</Button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 col-lg-12 col-xl-6">
                                <Form.Group className="custom_input_flled" controlId="">
                                    <Form.Control type="text" placeholder="EDI Inbox (SFTP Path)" className="filled_white " />
                                </Form.Group>
                            </div>
                            <div className="col-md-6 col-lg-12 col-xl-6">
                                <Form.Group className="custom_input_flled" controlId="">
                                    <Form.Control type="text" placeholder="Credentials / Key" className="filled_white " />
                                </Form.Group>
                            </div>
                        </div>
                        <div className="form_btn_flx justify-content-start">
                            <Button variant="primary" className="btn_sm">Test</Button>
                            <Button variant="light" className="btn_sm">Save</Button>
                        </div>
                    </div>
                    <div className="common_card common_card_grey medicaid_card">
                        <div className="top top_bar_flx border_tittle mby_16">
                            <div className="top_bar_tittle sm_tittle">
                                <h2 className="mb-1">SIMS</h2>
                                <p>Plan updates, task closures</p>
                            </div>
                            <div className="top_right_flx flex-wrap">
                                <Button variant="light" className="btn_sm"><TrashIcon /> Delete</Button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 col-lg-12 col-xl-6">
                                <Form.Group className="custom_input_flled" controlId="">
                                    <Form.Control type="text" placeholder="API / portal Link" className="filled_white " />
                                </Form.Group>
                            </div>
                            <div className="col-md-6 col-lg-12 col-xl-6">
                                <Form.Group className="custom_input_flled" controlId="">
                                    <Form.Control type="text" placeholder="Credentials / Key" className="filled_white " />
                                </Form.Group>
                            </div>
                        </div>
                        <div className="form_btn_flx justify-content-start">
                            <Button variant="primary" className="btn_sm">Test</Button>
                            <Button variant="light" className="btn_sm">Save</Button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="common_card mby_20">
                <div className="top top_bar_flx border_tittle mby_16">
                    <div className="top_bar_tittle">
                        <h2 className="mb-2">Automated Jobs</h2>
                        <p>Background jobs tied to September 2025. Toggle and run on‑demand as needed.</p>
                    </div>
                    <div className="top_right_flx flex-wrap">
                        <Button variant="primary" className="btn_sm">Add Automated Job</Button>
                    </div>
                </div>
                <div className="medicaid_card_grid">
                    <div className="common_card common_card_grey">
                        <div className="automated_jobs_card">
                            <div className="automated_jobs_card_left">
                                <h2>837P Send</h2>
                                <p>Cadence: Monthly on 1st biz day</p>
                                <p>Last: September 2025 precheck</p>
                                <p>Next: September 2025 final</p>
                            </div>
                            <div className="automated_jobs_card_right">
                                <Button variant="light" className="btn_sm"><TrashIcon />Delete</Button>
                                <h4>OK</h4>
                                <Button variant="light" className="btn_sm">Run</Button>
                            </div>
                        </div>
                    </div>
                    <div className="common_card common_card_grey">
                        <div className="automated_jobs_card">
                            <div className="automated_jobs_card_left">
                                <h2>835 Pull (RA)</h2>
                                <p>Cadence: Daily 6am</p>
                                <p>Last: 09/09/2025 06:01</p>
                                <p>Next: 09/10/2025 06:00</p>
                            </div>
                            <div className="automated_jobs_card_right">
                                <Button variant="light" className="btn_sm"><TrashIcon />Delete</Button>
                                <h4>OK</h4>
                                <Button variant="light" className="btn_sm">Run</Button>
                            </div>
                        </div>
                    </div>
                    <div className="common_card common_card_grey">
                        <div className="automated_jobs_card">
                            <div className="automated_jobs_card_left">
                                <h2>LaSRS Ingest (PA)</h2>
                                <p>Cadence: Daily 7am</p>
                                <p>Last: 09/09/2025 07:03</p>
                                <p>Next: 09/10/2025 07:00</p>
                            </div>
                            <div className="automated_jobs_card_right">
                                <Button variant="light" className="btn_sm"><TrashIcon />Delete</Button>
                                <h4>OK</h4>
                                <Button variant="light" className="btn_sm">Run</Button>
                            </div>
                        </div>
                    </div>
                    <div className="common_card common_card_grey">
                        <div className="automated_jobs_card">
                            <div className="automated_jobs_card_left">
                                <h2>270/271 Eligibility</h2>
                                <p>Cadence: Monthly pre-batch</p>
                                <p>Last: September 2025 precheck</p>
                                <p>Next: September 2025 final</p>
                            </div>
                            <div className="automated_jobs_card_right">
                                <Button variant="light" className="btn_sm"><TrashIcon />Delete</Button>
                                <h4>OK</h4>
                                <Button variant="light" className="btn_sm">Run</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Budgetconnectionstab;
